export default () => {
	const sections = document.querySelectorAll('.js-faq-section');
	sections.forEach((section) => {
		const items = section.querySelectorAll(".accordion button");
		items.forEach(item => item.addEventListener('click', ()=>{
			console.log('here')
			const _this = this
			const itemToggle = item.getAttribute('aria-expanded');

			for (let i = 0; i < items.length; i++) {
				items[i].setAttribute('aria-expanded', 'false');
			}
			if (itemToggle == 'false') {
				item.setAttribute('aria-expanded', 'true');
			}

		}));
	})
}
